module.exports = __webpack_public_path__ + "static/media/icon-ribbon.486a6f29.svg";